export const getWebSocketPayload = (webSocketEvent) => {
  return (
    webSocketEvent &&
    webSocketEvent.data &&
    webSocketEvent.data.arguments &&
    webSocketEvent.data.arguments[0] &&
    webSocketEvent.data.arguments[0].payload
  );
};

export const getWebSocketNotificationType = (webSocketEvent) => {
  return (
    webSocketEvent &&
    webSocketEvent.data &&
    webSocketEvent.data.arguments &&
    webSocketEvent.data.arguments[0] &&
    webSocketEvent.data.arguments[0].notificationEventType
  );
};
